module.exports = __webpack_public_path__ + "static/media/ad-age.06a3ea2c.jpg";